// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';
import type { Moment } from 'moment';
import { dateToString } from '../utils/date';
import CustomError from '../utils/error';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getPremiumAllocation = (
  policyId: string,
  dateChange: Moment,
  currencyId: number,
) => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');
  const dateStr = dateToString(dateChange);

  return backendAxios.get(`/policies/${policyId}/allocations/premium?date=${dateStr}&currencyId=${currencyId}`);
};

export default getPremiumAllocation;
